import axios from "axios";

export default class Schedule {
	constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
  }

  async getScheduleFile() {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/bin/files/transportation_schedules`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async postScheduleFile(url) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/bin/files/`,
        data: {
          fileName: "transportation_schedules",
          source: url
        }
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }
}
